import React, { useState, useEffect } from 'react';
import '../css/RatingChange.css';
import { RANK_DISPLAY, rankTierName } from './RankBadge';
import { useTranslation } from '../contexts/LanguageContext';

function RatingChange({ ratingUpdate }) {
    const [phase, setPhase] = useState('hidden');
    const { t, locale } = useTranslation();

    useEffect(() => {
        if (!ratingUpdate) return;
        const t1 = setTimeout(() => setPhase('enter'), 300);
        const t2 = setTimeout(() => setPhase('visible'), 600);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, [ratingUpdate]);

    if (!ratingUpdate) return null;

    const { ratingBefore, ratingAfter, ratingChange, rankTier, rankName, rankColor, tierChanged, proBonus } = ratingUpdate;
    const isPositive = ratingChange >= 0;

    return (
        <div className={`rating-change-container ${phase}`}>
            <div className="rating-change-card">
                <div className="rating-change-label">{t('game.rating.label')}</div>
                <div className="rating-numbers">
                    <span className="rating-before">{ratingBefore}</span>
                    <span className="rating-arrow">
                        <i className={`fas fa-arrow-${isPositive ? 'up' : 'down'}`}></i>
                    </span>
                    <span className="rating-after">{ratingAfter}</span>
                </div>
                <div className={`rating-delta ${isPositive ? 'positive' : 'negative'}`}>
                    {isPositive ? '+' : ''}{ratingChange.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
                </div>
                {proBonus > 0 && (
                    <div className="rating-pro-bonus" title={t('game.rating.proBonusTitle')}>
                        <i className="fas fa-bullseye"></i>
                        <span>{t('game.rating.proBonus', { percent: proBonus })}</span>
                    </div>
                )}
                {tierChanged && (
                    <div className="tier-promotion" style={{ borderColor: rankColor }}>
                        <i className={`fas ${RANK_DISPLAY[rankTier]?.icon || 'fa-star'}`} style={{ color: rankColor }}></i>
                        <span>{t.rich('game.rating.promoted', { b: <strong /> }, { rank: rankTierName(t, rankTier, rankName) })}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default RatingChange;
